import React from "react"
import { useTranslation } from "react-i18next"

import { FormTextField } from "@/nzds/forms/form-text-field/form-text-field"

interface CredentialNotesFieldValues {
  notes: string
}

export const CredentialNotesField: React.FC = () => {
  const { t } = useTranslation("common")

  return (
    <FormTextField<CredentialNotesFieldValues>
      label={t("admin.credentialsUi.notesLabel")}
      maxRows={12}
      minRows={4}
      multiline
      name="notes"
      variant="stacked"
    />
  )
}
